import { EdgeTypes } from '@xyflow/react'

import { FlowDefaultEdge } from './FlowDefaultEdge'

export const edgeTypes: EdgeTypes = {
  default: FlowDefaultEdge,
}
